<div mat-dialog-title>
  <h1 mat-dialog-title class="error-title"><b>Last known partner send issue</b></h1>
  <div class="col-md-12"><b>Operation ID:</b> {{ operationId }}</div>
  <div class="col-md-12"><b>Document:</b> {{ documentNumber }}</div>
  <div class="col-md-12"><b>Current status:</b> {{ status }}</div>
  <div class="col-md-12" *ngIf="recordedAt"><b>Recorded at:</b> {{ recordedAt }}</div>
  <div class="col-md-12"><b>Reason:</b> {{ error }}</div>
  <p class="hint">Historical record of the last partner send problem. The operation may have moved on since then.</p>
</div>

<div mat-dialog-content>
  <button mat-button type="button" (click)="close()">Close</button>
</div>
